import {modelsFromObject} from '../../helpers/models-from-object.js'

/** Return a copy of combatants where each combatant has a `belongsToTeam` value according to `teams` object */
//Also adds ID
export function addTeamReferencesAndIdsToCombatants(combatants = {}, teams = {}) {

  let payload = {...combatants};
  Object.keys(teams).forEach(teamId => {
    (teams[teamId].combatantIds || []).forEach(combatantId => {
      payload[combatantId].id = combatantId;
      payload[combatantId].belongsToTeam = teamId;
    });
  });

  return {...payload}
}


/* take in caster and return all teammate models as an ARRAY */
export function getAllTeammateModels(casterModel, allCombatantModels) {
  return modelsFromObject(allCombatantModels).filter(combModel => {
    return combModel.belongsToTeam === casterModel.belongsToTeam
  })
}

export function getAllEnemyModels(casterModel, allCombatantModels) {
  return modelsFromObject(allCombatantModels).filter(combModel => {
    return combModel.belongsToTeam !== casterModel.belongsToTeam
  })
}

/* Return combatants of one team (provided by teamId) */
export function getAllCombatantsOfTeam(teamId = "", allCombatantModels) {
  return modelsFromObject(allCombatantModels).filter(combModel => {
    return combModel.belongsToTeam === teamId
  })
}



// WEBPACK FOOTER //
// ./src/battle/lifecycle/team-utilities.js